"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3_1 = require("d3");
const lodash_1 = __importDefault(require("lodash"));
const lodash_find_1 = __importDefault(require("lodash.find"));
const lodash_min_1 = __importDefault(require("lodash.min"));
const lodash_map_1 = __importDefault(require("lodash.map"));
const lodash_some_1 = __importDefault(require("lodash.some"));
const lodash_flattendeep_1 = __importDefault(require("lodash.flattendeep"));
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const lodash_sortby_1 = __importDefault(require("lodash.sortby"));
const lodash_includes_1 = __importDefault(require("lodash.includes"));
const lodash_max_1 = __importDefault(require("lodash.max"));
const lodash_maxby_1 = __importDefault(require("lodash.maxby"));
const lodash_first_1 = __importDefault(require("lodash.first"));
const topojson_client_1 = require("topojson-client");
const canvas_1 = require("canvas");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const CanvasDrawer_1 = __importDefault(require("../../util/CanvasDrawer"));
const Cartogram_1 = __importDefault(require("../Cartogram"));
const util_1 = require("../Cartogram/util");
const Tooltip_1 = __importDefault(require("../Tooltip"));
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
const usStates_1 = require("../Cartogram/usStates");
require("./style.scss");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const constants_1 = require("../../constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const error_1 = require("../error");
const statesTopo = require('./states-10m.json');
const mapXAdjustment = 90;
function keyMatches(d, selected, xType) {
  if (xType && xType.toLowerCase() === 'items') {
    return d === selected;
  }
  if (!selected.getTime) {
    return d.getTime() === (0, chart_helpers_1.dateParser)(selected, xType).getTime();
  }
  return d.getTime() === selected.getTime();
}
function getValue(data, state, key) {
  const stateData = (0, lodash_find_1.default)(data, d => d.metric.geo_name === state);
  if (stateData === undefined) {
    return undefined;
  }
  const datum = (0, lodash_find_1.default)(stateData.metric.data, v => keyMatches(v.key, key, stateData.metric.xType));
  if (datum === undefined) {
    return null;
  }
  return datum.value;
}
function createScale(data, key, params) {
  const values = (0, lodash_1.default)(data).map('metric').flatMap(d => d.data.map(dd => ({
    ...dd,
    type: d.xType
  }))).filter(v => keyMatches(v.key, key, v.type)).map('value').value();
  const domainGenerator = (min, max, count) => (0, lodash_map_1.default)(Array(count), (v, i) => min + (max - min) / (count + 1) * (i + 1));
  const centeredDomainGenerator = (min, max, count) => {
    // TODO: rework this to work with all negative or positive values
    // if (min >= 0) {
    //     return  _map(Array(count), (v, i) => (max / (count + 1)) * (i + 1));
    // }
    // if (max < 0) {
    //     return  _map(Array(count), (v, i) => (min * -1 / (count + 1) * (i + 1) + min));
    // }
    if (min * -1 > max) {
      return (0, lodash_map_1.default)(Array(count), (v, i) => min * -2 / (count + 1) * (i + 1) + min);
    }
    return (0, lodash_map_1.default)(Array(count), (v, i) => max * 2 / (count + 1) * (i + 1) - max);
  };
  if (params.centeredScale) {
    return (0, d3_1.scaleThreshold)().domain(centeredDomainGenerator((0, lodash_min_1.default)(values), (0, lodash_max_1.default)(values), params.colourBins.length - 1)).range(params.colourBins);
  }
  return (0, d3_1.scaleThreshold)().domain(domainGenerator((0, lodash_min_1.default)(values), (0, lodash_max_1.default)(values), params.colourBins.length - 1)).range(params.colourBins);
}
function getColor(scale, value) {
  const domain = scale.domain()[scale.domain().length - 1] - scale.domain()[0];
  const maxOutlier = scale.domain()[scale.domain().length - 1] + domain;
  const minOutlier = scale.domain()[0] - domain;
  if (value === undefined || value === null || value > maxOutlier || value < minOutlier) {
    return 'rgb(185, 185, 185)';
  }
  return scale(value);
}
// meant to be used with centeredScale option turned on.
function getOutlineColour(value, params) {
  const cartoOptions = params.cartogramOptions;
  if (cartoOptions.posNegOutlineColours !== null) {
    if (value >= 0) {
      return cartoOptions.posNegOutlineColours[0];
    }
    return cartoOptions.posNegOutlineColours[1];
  }
  return cartoOptions.cartogramOutlineColour;
}
function format(func, value, options) {
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return func(value, options);
}
function drawLegend(_ref, formatFunc) {
  let {
    data,
    params
  } = _ref;
  const {
    margins,
    fontSize
  } = params;
  const scale = createScale(data, this.dropdownSelected, params);
  const values = (0, lodash_1.default)(data).map('metric').flatMap(d => d.data.map(dd => ({
    ...dd,
    type: d.xType
  }))).filter(v => keyMatches(v.key, this.dropdownSelected, v.type)).map('value').value();
  let min = (0, lodash_min_1.default)(values);
  let max = (0, lodash_max_1.default)(values);
  if (params.centeredScale) {
    if (min >= 0 || min * -1 < max) {
      min = max * -1;
    } else {
      max = min * -1;
    }
  }
  const ticks = (0, lodash_flattendeep_1.default)([min, scale.domain(), max]);
  const colors = scale.range();
  const top = this.height / 4;
  const length = this.height / 2;
  const left = this.width - margins.right - margins.legendPosition;
  const legendSpacing = 5;
  const lineWidth = 5;
  const textWidths = [];
  const dummyG = this.svg.append('g');
  dummyG.selectAll('.dummyText').data(ticks).enter().append('text').style('font-size', `${fontSize}px`).text(d => format(formatFunc, d, {
    ticks,
    autoSmallDecimals: true
  })).each(function () {
    const thisWidth = this.getComputedTextLength();
    textWidths.push(thisWidth);
    this.remove();
  });
  dummyG.remove();
  const longestWidth = Math.max(...textWidths);
  this.svg.selectAll('g.legend').data([scale]).enter().append('g').classed('legend', true);
  const legend = this.svg.selectAll('g.legend');
  const colorLines = legend.selectAll('line.color').data(colors);
  colorLines.enter().append('line').classed('color', true).merge(colorLines).attr('stroke-width', lineWidth).attr('x1', left).attr('x2', left).attr('y1', (d, i) => top + length / colors.length * (colors.length - i)).attr('y2', (d, i) => top + length / colors.length * (colors.length - i - 1)).attr('stroke', d => d);
  colorLines.exit().remove();
  const tickLabels = legend.selectAll('text.tick').data(ticks);
  tickLabels.enter().append('text').classed('tick', true).merge(tickLabels).style('font-size', `${fontSize}px`).attr('x', left + lineWidth + legendSpacing + longestWidth).attr('y', (d, i) => top + length / colors.length * (colors.length - i)).style('user-select', 'none').text(d => format(formatFunc, d, {
    ticks,
    autoSmallDecimals: true
  }));
  tickLabels.exit().remove();
}
function setTooltipColour(drawParams, scale, value) {
  const {
    useLegendExtremesTooltipColour,
    colourBins,
    primaryColor
  } = drawParams.params;
  if (useLegendExtremesTooltipColour) {
    const midValue = Math.floor(colourBins.length / 2);
    if (colourBins.indexOf(scale(0)) === midValue) {
      if (value < 0) {
        return colourBins[0];
      }
      if (value >= 0) {
        return colourBins[colourBins.length - 1];
      }
      // for null values greyed out
      return 'rgb(185, 185, 185)';
    }
    if (colourBins.indexOf(scale(value)) >= midValue) {
      return colourBins[colourBins.length - 1];
    }
    if (colourBins.indexOf(scale(value)) >= 0) {
      return colourBins[0];
    }
    // for null values greyed out
    return 'rgb(185, 185, 185)';
  }
  return primaryColor;
}
function showTooltip(drawParams, d, event, scale) {
  const {
    data,
    params: {
      cartogramOptions,
      cartogram,
      tooltipTitle,
      usaData
    }
  } = drawParams;
  this.svg.selectAll('path').style('stroke-width', null);
  (0, d3_1.select)(event.currentTarget).style('stroke-width', 4);
  if (this.hoveredArea !== d.properties.fips) {
    if (cartogram) {
      (0, d3_1.select)(event.currentTarget.parentNode).raise();
    } else {
      (0, d3_1.select)(event.currentTarget).raise();
    }
    if (!(0, lodash_some_1.default)(cartogramOptions.selectedStates, dd => dd !== d.properties.fips)) {
      (0, d3_1.selectAll)('g.cartogram-hex.selected').raise();
    }
    this.hoveredArea = d.properties.fips;
  }
  const containerDim = this.container.node().getBoundingClientRect();
  const {
    clientX: mouseX,
    clientY: mouseY
  } = event;
  const x = mouseX - containerDim.left;
  const y = mouseY - containerDim.top;
  const formatFunc = (0, chart_helpers_1.tooltipFormat)(drawParams);
  const value = getValue(data.concat(usaData), d.properties.name, this.dropdownSelected);
  const formattedValue = format(formatFunc, value);
  const tooltipColour = setTooltipColour(drawParams, scale, value);
  const topContent = {
    title: {
      value: tooltipTitle ?? d.properties.name
    },
    subtitle: {
      value: this.dropdownSelected
    }
  };
  this.tooltip.draw(x, y, topContent, [{
    type: 'value',
    value: formattedValue
  }], {
    primaryColour: tooltipColour
  });
}
function drawMap(drawParams) {
  const {
    data,
    params: {
      margins
    }
  } = drawParams;
  const lineChart = this;
  this.mapArea.on('mouseout', () => {
    this.tooltip.hide();
    this.svg.selectAll('path').style('stroke-width', null).filter(d => d.metric && d.metric.selectedState).raise();
  }, {
    passive: true
  });
  const [albersX, albersY] = (0, d3_1.geoAlbersUsa)().translate();
  const albersScale = (0, d3_1.geoAlbersUsa)().scale();
  const mapWidth = this.width - margins.left - margins.right - margins.legendPosition;
  const scale = mapWidth / ((albersX - mapXAdjustment) * 2);
  const projection = (0, d3_1.geoAlbersUsa)().scale(scale * albersScale).translate([scale * (albersX - mapXAdjustment) + margins.left, scale * albersY + margins.top]);
  const colorScale = createScale(data, this.dropdownSelected, drawParams.params);
  const mapFeatures = (0, topojson_client_1.feature)(statesTopo, statesTopo.objects.states).features.map(feature => {
    const metric = (0, lodash_find_1.default)(data, _ref2 => {
      let {
        fips
      } = _ref2;
      return fips === feature.id;
    });
    return {
      ...feature,
      metric
    };
  });
  this.mapArea.selectAll('path').data(mapFeatures, d => d.id).join('path').attr('d', (0, d3_1.geoPath)(projection)).on('mousemove', (0, lodash_throttle_1.default)((event, d) => {
    showTooltip.call(lineChart, drawParams, d, event, colorScale);
  }, constants_1.THROTTLE, {
    trailing: false
  }), {
    passive: true
  }).style('fill', d => getColor(colorScale, getValue(data, d.properties.name, this.dropdownSelected))).each(function (d) {
    const selection = (0, d3_1.select)(this);
    const isSelected = d.metric && d.metric.selectedState;
    if (isSelected) {
      selection.raise();
    }
    selection.classed('selected', isSelected);
  });
}
function drawCartogram(drawParams) {
  const {
    data,
    params: {
      margins,
      usaData
    }
  } = drawParams;
  const map = this;
  const scale = createScale(data, this.dropdownSelected, drawParams.params);
  const mapWidth = this.width - margins.left - margins.right * 2 - margins.legendPosition;
  const [albersX] = (0, d3_1.geoAlbersUsa)().translate();
  const sizeScale = mapWidth / (albersX * 2);
  const {
    radius
  } = (0, util_1.hexDimensions)(0, 0, this.width);
  const chartOptions = drawParams.params;
  chartOptions.cartogramOptions.colourFunction = d => getColor(scale, getValue(data.concat(usaData), d.properties.name, this.dropdownSelected));
  chartOptions.cartogramOptions.outlineFunction = d => getOutlineColour(getValue(data.concat(usaData), d.properties.name, this.dropdownSelected), drawParams.params);
  this.svg.select('g.cartogram').attr('transform', `scale(${sizeScale}) translate(${margins.left},${margins.top + radius / 2})`);
  this.cartogram.draw(chartOptions);
  this.cartogram.on('hover.__mapDefault', (d, event) => {
    showTooltip.call(map, drawParams, d, event, scale);
  }, {
    passive: true
  });
  this.cartogram.on('mouseout.__mapDefault', () => {
    this.tooltip.hide();
  }, {
    passive: true
  });
  this.cartogram.on('click.__mapDefault', () => {
    this.tooltip.hide();
  }, {
    passive: true
  });
}
function drawContent(drawParams) {
  this.cachedParams = drawParams;
  const formatFunc = (0, chart_helpers_1.valueFormat)(drawParams);
  const {
    data,
    params: {
      margins,
      info,
      hideYear,
      hideDropdown,
      useCartogramBounds,
      hideLegend,
      hideTitle,
      showSourcesAndFootnotes
    }
  } = drawParams;
  const [albersX, albersY] = (0, d3_1.geoAlbersUsa)().translate();
  const mapWidth = this.width - margins.left - margins.right - margins.legendPosition;
  this.height = albersY / (albersX - mapXAdjustment) * mapWidth + margins.top + margins.bottom;
  if (useCartogramBounds) {
    const {
      hexDi
    } = (0, util_1.hexDimensions)(1, 0, 1000, 4);
    this.height = (7 * hexDi * 0.75 + hexDi * 2) / (12 * hexDi) * mapWidth + margins.top + margins.bottom;
  }
  this.svg.attr('viewBox', `0 0 ${this.width} ${this.height}`);
  if (!hideTitle) {
    if (hideYear || hideDropdown) {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams, null);
    } else {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams, this.dropdownSelected);
    }
  }
  if (!hideLegend) {
    drawLegend.call(this, drawParams, formatFunc);
  }
  if (this.isCartogram) {
    drawCartogram.call(this, drawParams);
    this.svg.select('g.map-area').classed('hidden', true);
    this.svg.select('g.cartogram').classed('hidden', false);
  } else {
    drawMap.call(this, drawParams);
    this.svg.select('g.map-area').classed('hidden', false);
    this.svg.select('g.cartogram').classed('hidden', true);
  }
  if (info && info.position === 'chart') {
    InfoTooltip_1.default.inChart(this.container, {
      info
    });
  }
  if (showSourcesAndFootnotes) {
    this.sources.draw(data, drawParams.params);
  }
}
class Map {
  constructor(container) {
    this.chartType = constants_1.CHART_TYPES.Map;
    this.cssPrefix = 'map';
    this.dropdownSelected = null;
    this.margins = {
      top: 20,
      bottom: 20,
      left: 10,
      right: 20,
      legendPosition: 60
    };
    this.width = 960;
    this.isCartogram = false;
    this.container = container;
    if (this.container === undefined) {
      this.draw = this.drawCanvas;
      return;
    }
    this.title = container.append('div').classed('chart-title', true);
    this.subtitle = container.append('div').classed('chart-subtitle', true);
    this.svg = container.classed('map', true).classed('dh-chart-wrapper', true).append('svg');
    this.cartogram = new Cartogram_1.default(this.svg, {
      width: this.width,
      height: this.height,
      hide: true,
      standalone: false
    });
    this.hoveredArea = null;
    this.mapArea = this.svg.append('g').classed('map-area', true);
    this.sourceContainer = container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.tooltip = new Tooltip_1.default(container);
    error_1.initError.call(this);
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        if (this.width === containerWidth || containerWidth === 0) {
          return;
        }
        requestAnimationFrame(() => {
          this.width = containerWidth;
          this.redrawContent();
        });
      });
    });
    this.ro.observe(container.node());
  }
  setDropdownSelected(key) {
    this.dropdownSelected = key;
  }
  redrawContent() {
    if (this.cachedParams) {
      drawContent.call(this, this.cachedParams);
    }
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      topMetrics: usaMetric,
      parent
    } = fetched;
    const stateNames = (0, lodash_map_1.default)(usStates_1.states, 'name');
    const filtered = (0, lodash_1.default)(data).filter(d => (0, lodash_includes_1.default)(stateNames, d.metric.geo_name)).map(d => ({
      ...d,
      metric: {
        ...d.metric,
        data: (0, lodash_sortby_1.default)(d.metric.data, dd => dd.key)
      }
    })).value();
    let usaData = [];
    if (usaMetric && usaMetric.length > 0) {
      usaData = [{
        ...usaMetric[0],
        metric: {
          ...usaMetric[0].metric,
          geo_name: 'USA',
          data: (0, lodash_sortby_1.default)(usaMetric[0].metric.data, dd => dd.key)
        },
        selector: 'US',
        fips: '00'
      }];
    }
    let keysAreDates = true;
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    const keys = (0, lodash_1.default)(filtered).flatMap(d => d.metric.data.map(_ref3 => {
      let {
        key
      } = _ref3;
      if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') keysAreDates = false;
      return {
        key,
        xType: d.metric.xType
      };
    })).filter(v => {
      if (v.xType && v.xType.toLowerCase() === 'items') return true;
      if (startDate && v.key.getTime() < (0, chart_helpers_1.dateParser)(startDate, v.xType).getTime()) {
        return false;
      }
      if (endDate && v.key.getTime() > (0, chart_helpers_1.dateParser)(endDate, v.xType).getTime()) {
        return false;
      }
      return true;
    }).map(v => (0, chart_helpers_1.dateFormat)(v.key, v.xType)).uniq().value();
    if (this.dropdownSelected === null || !keys.includes(this.dropdownSelected)) {
      if (options.selectedYear !== undefined && keys.includes(options.selectedYear.toString())) {
        this.dropdownSelected = options.selectedYear;
      } else if (options.selectedDropdown !== undefined && keys.includes(options.selectedDropdown.toString())) {
        this.dropdownSelected = options.selectedDropdown;
      } else if (!keysAreDates) {
        this.dropdownSelected = (0, lodash_first_1.default)(keys);
      } else {
        this.dropdownSelected = (0, lodash_maxby_1.default)(keys, d => new Date(d));
      }
    }
    if (options.forceYear && keys.includes(options.forceYear.toString())) {
      this.dropdownSelected = options.forceYear;
    }
    if (options.forceDropdown && keys.includes(options.forceDropdown.toString())) {
      this.dropdownSelected = options.forceDropdown;
    }
    return {
      data: filtered,
      usaData,
      parent,
      keys
    };
  }
  static getColourBins(colourBins, colourScale, centeredScale) {
    if (Array.isArray(colourBins) && colourBins.length > 2) {
      return colourBins;
    }
    if (colourScale && constants_1.COLOUR_SCALES[colourScale] !== undefined) {
      return constants_1.COLOUR_SCALES[colourScale];
    }
    if (centeredScale) {
      return constants_1.COLOUR_SCALES.divergingYellowGreen;
    }
    return constants_1.COLOUR_SCALES.sequentialYellowGreen;
  }
  getDrawParams(_ref4) {
    let {
      data,
      usaData,
      parent,
      options: {
        cartogram = false,
        hideYear = false,
        hideDropdown = false,
        colourBins = null,
        colourScale = null,
        selectedStates = [],
        centeredScale = false,
        primaryColor = null,
        useLegendExtremesTooltipColour = false,
        cartogramOptions = {},
        hideLegend = false,
        useCartogramBounds = false,
        hideTitle = false,
        showSourcesAndFootnotes = true,
        tooltipTitle = null,
        ...otherOptions
      }
    } = _ref4;
    const bins = Map.getColourBins(colourBins, colourScale, centeredScale);
    return {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        parent,
        options: otherOptions
      }, this.margins),
      usaData,
      cartogram,
      hideYear,
      hideDropdown,
      colourBins: bins,
      selectedStates,
      centeredScale,
      primaryColor: primaryColor || bins.slice(-1)[0] || colours_module_scss_1.default.chartcolourdefault8,
      useLegendExtremesTooltipColour,
      cartogramOptions: {
        autoLabelColour: true,
        cartogramOutlineColour: '#015193',
        makeUSABigger: false,
        posNegOutlineColours: null,
        selectableCartogram: false,
        showUSA: false,
        ...cartogramOptions
      },
      hideLegend,
      useCartogramBounds,
      hideTitle,
      showSourcesAndFootnotes,
      tooltipTitle
    };
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data,
      usaData,
      parent,
      keys
    } = allData;
    const optionParams = this.getDrawParams({
      data,
      usaData,
      parent,
      options
    });
    if (optionParams.hideLegend) {
      optionParams.margins.legendPosition = 0;
    }
    optionParams.selectableYears = Object.prototype.hasOwnProperty.call(options, 'selectableYears') ? options.selectableYears : true;
    optionParams.selectableDropdowns = Object.prototype.hasOwnProperty.call(options, 'selectableDropdowns') ? options.selectableDropdowns : true;
    const drawParams = {
      data,
      parent,
      keys,
      params: optionParams
    };
    this.isCartogram = options.cartogram;
    if (optionParams.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node());
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node());
    } else if (optionParams.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
      this.container.node().append(this.sourceContainer.node());
    }
    drawContent.call(this, drawParams);
    return true;
  }
  async drawCanvas(dataPromises) {
    let chartOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let {
      margin = 40,
      width = 720,
      scale = 3,
      key = undefined,
      showText = true,
      showBranding = true,
      xOffset = 0,
      yOffset = 0
    } = arguments.length > 2 ? arguments[2] : undefined;
    let canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, canvas_1.createCanvas)(width, width);
    const allData = await this.data(dataPromises, chartOptions);
    if (!allData) return canvas;
    const {
      data,
      parent
    } = allData;
    const params = this.getDrawParams({
      data,
      parent,
      options: chartOptions
    }, this.margins);
    const {
      margins
    } = params;
    if (margin !== null) {
      params.margins.left = margin;
      params.margins.right = margin;
    }
    const selectedKey = key || this.dropdownSelected;
    const colorScale = createScale(data, selectedKey, params);
    const logoOffset = 20 + margin + 20;
    const titleOffset = params.titleFontSize * parseFloat(common_module_scss_1.default.chartTitleLineHeight);
    const hasSubtitle = params.subtitle !== '';
    const subtitleOffset = hasSubtitle ? params.subtitleFontSize * parseFloat(common_module_scss_1.default.chartSubtitleLineHeight) : 0;
    const footerHeight = margin + 20;
    const [albersX, albersY] = (0, d3_1.geoAlbersUsa)().translate();
    const mapWidth = width - margins.left - margins.right - (showText ? margins.legendPosition : 0);
    const mapHeight = mapWidth / (albersX - mapXAdjustment) * albersY;
    const oldWidth = this.width;
    const oldHeight = this.height;
    this.width = width;
    this.height = mapHeight + margins.top + margins.bottom;
    // canvas manipulation causes side effects
    // eslint-disable-next-line no-param-reassign
    canvas.width = width * scale;
    // eslint-disable-next-line no-param-reassign
    canvas.height = (this.height + logoOffset + titleOffset + subtitleOffset + footerHeight) * scale;
    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.scale(scale, scale);
    const {
      features
    } = (0, topojson_client_1.feature)(statesTopo, statesTopo.objects.states);
    CanvasDrawer_1.default.drawMap(canvas, data, features, mapWidth, margins.left, logoOffset + titleOffset + subtitleOffset, (d, name) => getColor(colorScale, getValue(d, name, selectedKey)));
    const chartOffset = yOffset + logoOffset + titleOffset + subtitleOffset;
    if (showText) {
      CanvasDrawer_1.default.drawMapLegend(canvas, data, selectedKey, params, colorScale, mapHeight / 2, (0, chart_helpers_1.valueFormat)({
        data,
        parent,
        params
      }), width - margins.right - margins.legendPosition, mapHeight / 4 + logoOffset + titleOffset + subtitleOffset);
      CanvasDrawer_1.default.drawTitles.call(this, canvas, params, selectedKey, (0, chart_helpers_1.primaryColour)(params), undefined, undefined, xOffset, yOffset + logoOffset);
      if (showBranding) {
        await CanvasDrawer_1.default.drawLogo(canvas, width, params, margin);
        CanvasDrawer_1.default.drawFooter(canvas, width, chartOffset + mapHeight + margins.top + margins.bottom + 20);
      }
    }
    this.width = oldWidth;
    this.height = oldHeight;
    return canvas;
  }
}
exports.default = Map;